module.exports = __webpack_public_path__ + "static/img/疼痛.16992fcb.jpg";